@if (!loadingProvider) {
  <div class="mt-2">
    <h3>Provider Details Change Log: {{ provider.fullName }}</h3>
    @if (!loadingAudits) {
      <div>
        <div class="col-12">
          <app-pagination-header [paging]="paging" [label]="'audits'" (pageSizeChange)="onPageSizeChange($event)" />
        </div>
        <div class="audit-list-wrapper col-12">
          <table class="audit-list table table-bordered table-hover">
            <thead class="table-dark">
              <tr>
                <th>Changed At</th>
                <th>Action</th>
                <th>New Values</th>
                <th>Previous Values</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody>
              @for (audit of audits; track audit) {
                @if (audit.auditableType === 'Provider' && audit.action === 'create') {
                  <tr
                    app-audit-provider-create-row
                  [audit]="audit"></tr>
                }
                @if (audit.auditableType === 'Provider' && audit.action === 'update') {
                  <tr
                    app-audit-provider-update-row
                  [audit]="audit"></tr>
                }
                @if (audit.auditableType === 'Note' && audit.action === 'create') {
                  <tr
                    app-audit-note-create-row
                  [audit]="audit"></tr>
                }
                @if (audit.auditableType === 'ProviderOffice' && audit.action === 'create') {
                  <tr
                    app-audit-provider-office-create-row
                    [audit]="audit"
                  [displayFax]="true"></tr>
                }
                @if (audit.auditableType === 'ProviderOffice' && audit.action === 'update') {
                  <tr
                    app-audit-provider-office-update-row
                    [audit]="audit"
                  [displayFax]="true"></tr>
                }
                @if (audit.auditableType === 'ProviderSpecialtyDataReview' ||
                     audit.auditableType === 'ProviderFaxNumberDataReview') {
                  @if (audit.action === 'create' ) {
                    <tr
                      app-audit-provider-data-review-create-row
                      [audit]="audit"
                    ></tr>
                  }
                  @if (audit.action === 'update') {
                    <tr
                      app-audit-provider-data-review-update-row
                      [audit]="audit"
                    ></tr>
                  }
                }
              }
            </tbody>
          </table>
          <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
        </div>
      </div>
    } @else {
      <mat-spinner diameter="30" />
    }
  </div>
} @else {
  <mat-spinner diameter="30" />
}
